export default __webpack_public_path__ + "static/media/gallery - spells_01.2f89ec00.jpg";